import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import APIUtilities from './APIUtilities.js'
import SkeletonCard from "./SkeletonCard";
import { track } from './posthog';



export default class PhoneResults extends PureComponent {

  constructor(props) {
    super(props);

    // Compteur de requêtes : seule la réponse de la dernière requête lancée est appliquée.
    // Protège contre la race où une requête large (ex : "s") résout après une requête
    // ciblée (ex : "s24") et écrase les bons résultats.
    this.latestRequestId = 0;

    this.state = {
      firstLoad : true,
      IDPiece : this.props.category.IDPiece,
      phoneList : {"modele_LIST" : []}
    };
  };

  static propTypes = {
    brandID: PropTypes.number,
    search: PropTypes.string,
    onClickFunction: PropTypes.func
  };

  componentDidMount() {
    this.generatePhoneList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.search !== prevProps.search) {
      this.generatePhoneList();
    }
  }

  async generatePhoneList() {

    const requestId = ++this.latestRequestId;

    //const list = await APIUtilities.generatePhoneList(this.props.brandID, this.props.search);
    const list = await APIUtilities.generatePhoneListByPiece(this.props.brandID, this.state.IDPiece, this.props.search);

    // Réponse périmée (une requête plus récente a été lancée entre-temps) : on l'ignore.
    if (requestId !== this.latestRequestId)
      return;

    this.setState({
      firstLoad : false,
      phoneList : list
    });

    // Recherche infructueuse : seul l'item "Autre" (IDModele=0) revient, alors qu'une recherche réelle a été saisie.
    const search = this.props.search;
    const modeles = (list && list.modele_LIST) ? list.modele_LIST : [];
    const nbReels = modeles.filter(p => parseInt(p.IDModele) !== 0).length;
    if(nbReels === 0 && search && search !== "-1") {
      track('devis_recherche_sans_resultat', {
        recherche: search,
        marque_id: this.props.brandID,
        categorie_id: this.props.category ? this.props.category.IDCategorie : undefined,
      });
    }
  }

  selectPhone(phone) {
  this.props.onClickFunction(phone);
  };

  render() {
    if(this.state.firstLoad)
      return <SkeletonCard nbItems="16"/>;

    return (
      <div className="component-grid-list">
        {this.state.phoneList.modele_LIST.map(phone => (
          <div className="component-grid-element component-results-element" id="component-phones-results-element" key={phone.IDModele} onClick={this.selectPhone.bind(this, phone)}>
            <img alt="" src={phone.URL_IMG}/>
            <span className="component-grid-element-title" id="component-phones-title-element">{phone.LibelleModele}</span>
          </div>
        ))}
      </div>
    );
    }
}
